import { ADD_DATA } from '@constants/general';

export const filterAddOrEdit = (file, type) => {
  if (type === ADD_DATA) {
    if (!file?.sourceHasBeenProcessed) return file?.id;
  } else {
    return file?.id;
  }
};
